export default [{
  path: '/ParticipationDoc',//证件管理办法
  name: 'docPage',
  component: () => import('@/view/ParticipationSpa/doc.vue')
},
// {
//   path: '/ParticipationMerchant',//客商团组
//   name: 'MerchantPage',
//   component: () => import('@/view/ParticipationSpa/merchant.vue')
// },
{
  path: '/ParticipationContact',//联络组委会各工作机构 联络方式
  name: 'contactP',
  component: () => import('@/view/ParticipationSpa/contact.vue')
},{
  path: '/ParticipationNotice',//报到须知
  name: 'noticeP',
  component: () => import('@/view/ParticipationSpa/notice.vue')
},{
  path: '/ParticipationTranslate',//翻译服务
  name: 'translateP',
  component: () => import('@/view/ParticipationSpa/translate.vue')
},{
  path: '/Participationmsg',//信息服务
  name: 'msgP',
  component: () => import('@/view/ParticipationSpa/msg.vue')
},{
  path: '/ParticipationIntercity',//信息服务
  name: 'IntercityP',
  component: () => import('@/view/ParticipationSpa/Intercity.vue')
},{
  path: '/ParticipationTraffic',//市内交通
  name: 'trafficP',
  component: () => import('@/view/ParticipationSpa/traffic.vue')
},{
  path: '/ParticipationPic',//展馆接驳车  展馆停车
  name: 'picP',
  component: () => import('@/view/ParticipationSpa/pic.vue')
},{
  path: '/ParticipationFood',//展馆餐饮
  name: 'foodP',
  component: () => import('@/view/ParticipationSpa/food.vue')
},{
  path: '/ParticipationMedical',//医疗服务
  name: 'medicalP',
  component: () => import('@/view/ParticipationSpa/medical.vue')
},{
  path: '/ParticipationBusiness',//展馆商务服务
  name: 'businessP',
  component: () => import('@/view/ParticipationSpa/business.vue')
},{
  path: '/ParticipationSpapdf',//大会指南 推介书 组位会各工作结构办公驻地及联络电话 客商团组
  name: 'pdfP',
  component: () => import('@/view/ParticipationSpa/pdf.vue')
},]




// WEBPACK FOOTER //
// ./src/router/ParticipationSpa.js